<template>
  <div>
    <mds-combo-box
      label="Select your regional calendar"
      placeholder="Select an Option"
      size="small"
      :selected-items="[selectedCountry]"
      :data-set="countries"
      @input="
        selectedCountry = $event[0]
        $emit('selectedCountry', $event[0])
      "
    />
    <mds-button
      class="holidays-field__button-list"
      v-if="selectedCountry"
      size="small"
      variation="flat"
      @click="showHolidays = !showHolidays"
    >
      List of {{ modalTitle }}
    </mds-button>
    <mds-modal
      action-required
      class="holidays-field__modal-list"
      v-model="showHolidays"
    >
      <mds-section
        class="holidays-field__section"
        bold
        border="none"
        :size="7"
        :title="modalTitle"
      >
        <template #mds-section-actions>
          <mds-button
            class="holidays-field__close-button"
            variation="icon-only"
            icon="remove"
            @click="showHolidays = !showHolidays"
          />
        </template>
        <mds-table>
          <mds-tbody class="holidays-field__table-body">
            <mds-tr v-for="({ date, name }, index) in holidays" :key="index">
              <mds-td class="holidays-field__table-cell">
                {{ date }}
              </mds-td>
              <mds-td class="holidays-field__table-cell">
                {{ name }}
              </mds-td>
            </mds-tr>
          </mds-tbody>
        </mds-table>
      </mds-section>
    </mds-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MdsButton } from '@mds/button'
import MdsComboBox from '@mds/combo-box'
import MdsModal from '@mds/modal'
import MdsSection from '@mds/section'
import { MdsTable, MdsTbody, MdsTr, MdsTd } from '@mds/data-table'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/frequencyModal/config/i18n'

export default {
  name: 'HolidaysField',
  components: {
    MdsButton,
    MdsComboBox,
    MdsModal,
    MdsSection,
    MdsTable,
    MdsTbody,
    MdsTr,
    MdsTd,
  },
  props: {
    selectedData: {
      type: String,
      default: '',
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      selectedCountry: '',
      showHolidays: false,
    }
  },
  created() {
    this.selectedCountry = this.selectedData.includes('-Business')
      ? this.selectedData.split('-')[0]
      : this.selectedCountry
  },
  computed: {
    ...mapState({
      storedHolidays: (state) => state.cache.cache.holidays,
    }),
    modalTitle() {
      if (this.storedHolidays.length > 0) {
        const year = this.storedHolidays[0].year
        const countryName = this.storedHolidays.find(
          (item) => item.country_code === this.selectedCountry
        )?.country_name
        return `${year} ${countryName} Bank Holidays`
      }
      return 'Bank Holidays'
    },
    countries() {
      return this.storedHolidays
        .map((item) => ({
          text: item.country_name,
          value: item.country_code,
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },
    holidays() {
      const countryData = this.storedHolidays.find(
        (item) => item.country_code === this.selectedCountry
      )
      this.$emit(
        'selectedHolidays',
        this.getHolidays(countryData?.holidays || [])
      )
      return countryData ? countryData?.holidays : []
    },
  },
  methods: {
    getHolidays(holidays) {
      return holidays.map((holiday) => holiday.date)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';
.holidays-field {
  &__button-list {
    color: $mds-color-black;
    margin-top: $mds-space-2-x;
    :hover {
      color: $mds-color-blue-36;
    }
    :first-child {
      text-decoration-line: underline;
    }
  }
  &__modal-list {
    &::v-deep [class^='mds-modal__wrapper'] {
      width: 450px;
      border: solid 1px #cccccc !important;
      border-radius: 6px !important;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2) !important;
    }
  }
  &__section {
    &::v-deep [class^='mds-section__header-container'] {
      border-bottom: solid 1px;
      margin-bottom: $mds-space-1-x;
    }
  }
  &__close-button {
    bottom: $mds-space-half-x;
  }
  &__table {
    &-body {
      tr:first-child {
        td {
          border-top: none;
        }
      }
    }
    &-cell {
      @include mds-body-text-s();
    }
  }
}
</style>
